import { type Options } from "canvas-confetti";
import type { TupleToUnion } from "type-fest";

export const GAME_MODES = ["classic", "mcq", "imcq"] as const;
export type GameMode = TupleToUnion<typeof GAME_MODES>;

export const STREAK_REQ_FOR_HINT = 5;
export const REWARD_TIME_PER_CORRECT_ANSWER = 3; // in seconds

export const CONFETTI_BLASTS: Options[] = [
  // blast confetti toward the center from all four corners
  {
    angle: -45,
    origin: {
      x: 0,
      y: 0,
    },
  },
  {
    angle: -135,
    origin: {
      x: 1,
      y: 0,
    },
  },
  {
    angle: 45,
    origin: {
      x: 0,
      y: 1,
    },
  },
  {
    angle: 135,
    origin: {
      x: 1,
      y: 1,
    },
  },
];
